/**
 * Remove-cut confirmation strings in en / fr / es. `areYouSure` and `yesRemove` are English in
 * all three languages.
 */
import { LanguageContent } from "@ryerson/frontend.common";

/** Remove-cut confirmation strings for one language. */
export interface RemoveDefineCutText {
	removeCut: string;
	areYouSure: string;
	yesRemove: string;
	cancel: string;
	back: string;
}

/** Remove-cut confirmation strings per language. `RemoveCutModal` falls back to `en`. */
export const RemoveDefineCutContent: LanguageContent<RemoveDefineCutText> = {
	en: {
		removeCut: "Remove Cut",
		areYouSure:
			"Are you sure you want to remove the cut specifications? This action cannot be undone.",
		yesRemove: "Yes, Remove",
		cancel: "Cancel",
		back: "Back",
	},
	fr: {
		removeCut: "Supprimer la coupe",
		areYouSure:
			"Are you sure you want to remove the cut specifications? This action cannot be undone.",
		yesRemove: "Yes, Remove",
		cancel: "Annuler",
		back: "Retour",
	},
	es: {
		removeCut: "Eliminar corte",
		areYouSure:
			"Are you sure you want to remove the cut specifications? This action cannot be undone.",
		yesRemove: "Yes, Remove",
		cancel: "Cancelar",
		back: "Atrás",
	},
};
